<template>
    <div v-if="!config.modules.catalog_mode">
        <a v-if="dataProduct.variations.length" :href="dataProduct.url" class="btn btn-secondary">
            <i class="fas fa-tasks fa-fw"></i> {{ t.product.select_options }}
        </a>
        <div v-else>
            <button :disabled="!dataProduct.canBeOrdered" class="btn btn-primary" @click="addToCart">
                <i class="fas fa-shopping-bag fa-fw"></i> {{ t.product.add_to_cart }}
            </button>
            <a v-if="config.modules.buy_now && dataProduct.canBeOrdered" class="btn btn-link ms-2 text-decoration-none text-muted" :href="dataProduct.buyNow"><i class="fa-solid fa-forward"></i> {{ t.product.buy_now }}</a>
        </div>
    </div>
</template>

<script>
    import store from "../CartStore";
    export default {
        props: ['dataProduct'],
        store: store,
        data() {
            return {
                t: t,
                config: config,
                settings: settings,
            };
        },
        methods: {
            ...Vuex.mapActions(['addProduct']),
            addToCart() {
                this.dataProduct.qty = 1
                this.addProduct(this.dataProduct);
            },
        },
    }
</script>
